import { AdminLayout } from "components/admin/admin-layout";
import { EmptySearchResults } from "components/admin/dashboard/empty-searchs";
import { PifJar } from "components/admin/dashboard/pif-jar";
import { ClientOnly } from "components/client-only";
import { GetServerSideProps } from "next";
import Head from "next/head";

interface Props {
  sevenDaysAgo: string;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const sevenDaysAgo = new Date(
    Date.now() - 7 * 24 * 60 * 60 * 1000
  ).toISOString();

  return {
    props: { sevenDaysAgo } as Props,
  };
};

export const Dashboard = ({ sevenDaysAgo }: Props) => {
  return (
    <>
      <Head>
        <title>Admin | Dashboard</title>
      </Head>
      <AdminLayout page='Dashboard'>
        <article className='space-y-4'>
          <header className='flex flex-col xl:flex-row flex-wrap w-full justify-center space-y-4 xl:space-y-0 xl:space-x-4'>
            <h1 className='header text-4xl ml-auto mr-auto xl:ml-0 xl:mr-auto'>
              Dashboard
            </h1>
          </header>
          <section className='grid sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4'>
            <PifJar />
            <EmptySearchResults sevenDaysAgo={sevenDaysAgo} />

            {/* <SalesDash /> */}
          </section>
        </article>
      </AdminLayout>
    </>
  );
};

export default Dashboard;
